import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from './CtaButton';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-166" data-mp="3ud54jjuwfurq">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t-2 border-ink bg-cream/95 backdrop-blur" data-id="element-167" data-mp="3ubu1xnd6wt27">
          <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3 sm:px-8 gap-[0px]" data-id="element-168" data-mp="c55wtxi545wj">
            <div className="min-w-0" data-id="element-169" data-mp="75vs3d682p9r">
              <p className="truncate font-display text-sm font-bold sm:text-base" data-id="element-170" data-mp="76xdaagycs57">
                Manos a la Casa · 6 tomos + 5 bonos
              </p>
              <p className="truncate text-xs text-graphite/80" data-id="element-171" data-mp="24yd19giebch">
                Acceso digital inmediato
              </p>
            </div>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex shrink-0 items-center gap-2 rounded-full border-2 border-ink bg-clay px-5 py-3 font-display text-sm font-bold text-cream transition-colors hover:bg-clayDark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink" data-id="element-172" data-mp="c4p8bdcw8udm">
              Quiero acceso
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-173" data-mp="uv6vz3ivczs4" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}